import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5471c78b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-list" }
const _hoisted_2 = {
  key: 0,
  class: "product"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline = _resolveComponent("headline")!
  const _component_goods_list = _resolveComponent("goods-list")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_headline, {
        title: "You May Also Like",
        size: "18",
        backgourdColor: "#F5F5F5",
        colors: "#000",
        boundary: true
      })
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_list, {
        loading: $setup.loading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
        finished: $setup.finished,
        "finished-text": "No more",
        "loading-text": "loading",
        onLoad: $setup.onLoad
      }, {
        default: _withCtx(() => [
          ($setup.product.list && $setup.product.list.length>0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.product.list, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.goods_id
                  }, [
                    _createVNode(_component_goods_list, { data: item }, null, 8, ["data"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])
    ])
  ], 64))
}